import { render, staticRenderFns } from "./ScoreStartList.vue?vue&type=template&id=d2cc8cdc&scoped=true&"
import script from "./ScoreStartList.vue?vue&type=script&lang=js&"
export * from "./ScoreStartList.vue?vue&type=script&lang=js&"
import style0 from "./ScoreStartList.vue?vue&type=style&index=0&id=d2cc8cdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2cc8cdc",
  null
  
)

export default component.exports